import { Target } from '../entities/Target';
export const initTarget = (ctx, mesh) => {
    mesh.setParent(null);
    ctx.setTarget(new Target(ctx, mesh));
};
